<template>
  <div>
    <el-menu default-active="2" class="el-menu-vertical-demo">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-s-management"></i>
          <span>Контент</span>
        </template>

        <el-menu-item @click="goToPage('/banners')" index="1-2"
          >Баннеры</el-menu-item
        >
        <el-menu-item @click="goToPage('/advantages')" index="1-3"
          >Преимущества</el-menu-item
        >
        <el-menu-item @click="goToPage('/main-slides')" index="1-4"
          >Слайды на главной</el-menu-item
        >
        <el-menu-item @click="goToPage('/text-pages')" index="1-5">
          Текстовые страницы
        </el-menu-item
        >
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-shopping-cart-full"></i>
          <span>Каталог товаров</span>
        </template>
        <el-menu-item index="2-1" @click="goToPage('/products')"
          >Товары</el-menu-item
        >
        <el-menu-item index="2-2" @click="goToPage('/collections')"
          >Коллекции</el-menu-item
        >
        <el-menu-item index="2-3" @click="goToPage('/catalog-sections')"
          >Разделы каталога</el-menu-item
        >
        <!-- <el-menu-item index="2-3" @click="goToPage('/presets')"
          >Заготовленные фильтры</el-menu-item
        > -->
        <el-menu-item index="2-4" @click="goToPage('/selections')"
          >Тематические подборки</el-menu-item
        >
        <el-menu-item index="2-5" @click="goToPage('/popular')"
          >Популярные подборки</el-menu-item
        >

      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-s-comment"></i>
          <span>Блог</span>
        </template>
        <el-menu-item index="3-1" @click="goToPage('/articles')"
          >Статьи</el-menu-item
        >
        <el-menu-item index="3-2" @click="goToPage('/article-sections')"
          >Категории статей</el-menu-item
        >
      </el-submenu>

      <el-menu-item index="4-1" @click="goToPage('/users')">
        <template slot="title">
          <i class="el-icon-user"></i>
          <span>Пользователи</span>
        </template>
      </el-menu-item>

      <el-submenu index="5">
        <template slot="title">
          <i class="el-icon-question"></i>
          <span>FAQ</span>
        </template>
        <el-menu-item index="5-1" @click="goToPage('/faq-sections')"
          >Разделы FAQ</el-menu-item
        >
      </el-submenu>

      <el-menu-item index="6" @click="goToPage('/storages')">
        <template slot="title">
          <i class="el-icon-s-home"></i>
          <span>Склады</span>
        </template>
      </el-menu-item>

      <el-submenu index="6-1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>Доставки</span>
        </template>
        <el-menu-item index="6-2" @click="goToPage('/regions')">          
          <span>Населенные пункты</span>
        </el-menu-item>
        <el-menu-item index="6-3" @click="goToPage('/transport-companies')">
          <span>Транспортные компании</span>
        </el-menu-item>
      </el-submenu>

      <el-menu-item @click="goToPage('/promo-actions')" index="7-1">
        <template slot="title">
          <i class="el-icon-s-flag"></i>
          <span>Акции</span>
        </template>
      </el-menu-item>
      <el-submenu index="8">
        <template slot="title">
          <i class="el-icon-s-platform"></i>
          <span>Модерация</span>
        </template>
        <el-menu-item index="8-1" @click="goToPage('/reviews')">
          <span>Отзывы</span>
          <el-badge
            v-if="getQuantityReviews !== 0"
            :value="getQuantityReviews"
          />
        </el-menu-item>
        <el-menu-item index="8-2" @click="goToPage('/comments')">
          <span>Комментарии к статьям</span>
          <el-badge
            v-if="getQuantityComments !== 0"
            :value="getQuantityComments"
          />
        </el-menu-item>
      </el-submenu>
      <el-menu-item @click="goToPage('/request-calls')" index="9-1">
        <template slot="title">
          <i class="el-icon-phone-outline"></i>
          <span>Заявки на звонок</span>
          <el-badge v-if="getQuantityCalls !== 0" :value="getQuantityCalls" />
        </template>
      </el-menu-item>
      <el-menu-item @click="goToPage('/orders')" index="10-1">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>Заказы</span>
        </template>
      </el-menu-item>
      <el-menu-item @click="goToPage('/mailing')" index="12-1">
        <template slot="title">
          <i class="el-icon-message"></i>
          <span>Рассылка</span>
        </template>
      </el-menu-item>
      <el-submenu index="11">
        <template slot="title">
          <i class="el-icon-discount"></i>
          <span>Система лояльности</span>
        </template>
        <el-menu-item index="11-1" @click="goToPage('/discount-cards')"
          >Дисконтные карты</el-menu-item
        >
      </el-submenu>
      <!-- <el-menu-item index="12" @click="goToPage('/application-forms')" disabled
        ><i class="el-icon-user"></i>Пользователи с 1С</el-menu-item
      > -->
      <el-menu-item @click="goToPage('/config')" index="13">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>Конфигурация</span>
        </template>
      </el-menu-item>
    </el-menu>
    
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data: function () {
    return {
      countRequest: 0,
      countComment: 0,
      countReview: 0,
    };
  },
  computed: {
    getQuantityCalls() {
      return this.$store.state.QuentityItems.quantityCalls;
    },
    getQuantityReviews() {
      return this.$store.state.QuentityItems.quantityReviews;
    },
    getQuantityComments() {
      return this.$store.state.QuentityItems.quantityComments;
    },
  },
  methods: {
    goToPage: function (path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
</style>